import AccountRoleDTO from 'features/accounts/dtos/AccountRoleDTO';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import React from 'react';
import { Modal } from 'react-bootstrap';
import AccountRoleSelect from 'features/accounts/components/AccountRoleSelect';
import ModalFooter from 'features/shared/components/modal/ModalFooter';
import { Nullable } from 'features/shared/types/nullable';
import { useForm } from 'features/shared/forms/hooks/useForm';
import { accountRoleValidations } from './accountRoleValidations'
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import { AccountRoles_AccountRoleDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  disabledRoles?: AccountRoleDTO[];
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (role: AccountRoleDTO) => void;
}

const AccountRoleDialog = ({ show, disabledRoles, setShow, onSubmit }: Props) => {
  // translations
  const tLabels = useTranslation("accounts\\accounts").t;

  // form hook
  const { values, errors, setFormValue, clearForm, valideteForm, validateFormField } = useForm({
    initialValidations: accountRoleValidations()
  });

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let role: AccountRoleDTO = {...values};

      onSubmit(role);
      clearForm();
    }
  };

  const closeDialogHandler = () => {
    clearForm();
    setShow(false);
  };
  
  const roleChangeHandler = (role: Nullable<AccountRoleDTO>) => {
    if (validateFormField("role", role)) {
      setFormValue("role", role?.role);   
    }
  }

  // render
  return (
    <Modal show={show} onHide={closeDialogHandler} backdrop="static">
      <ModalHeader
        title={tLabels("accountRoleDialog.cardTitle")}
        onCloseClick={closeDialogHandler}
      />
      <form onSubmit={submitFormHandler}>
        <div className="modal-body py-4">
          <AccountRoleSelect 
            name="role"
            onChange={roleChangeHandler}
            disabledRoles={disabledRoles}
            errors={errors}
          />
        </div>
        <ModalFooter>
          <button type="submit" className="btn btn-primary">
            {tLabels("accountRoleDialog.addRole")}
          </button>
        </ModalFooter>
      </form>
      <PromiseLoadingSpinner area={AccountRoles_AccountRoleDialog} />
    </Modal>
  );
}

export default AccountRoleDialog;
